<template>
    <div class="header bg-darkGrey">
        <div class="outer"></div>
        <div class="inner">
            <h4 class="txt-white">{{title}}</h4>
            <div class="divider"></div>
            <h4 class="txt-white">{{body}}</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "fruitmachineHeader",
    computed: {
        containerSize() {
            if(this.gameType == "fruitmachine") {
                return ""
            } else {
                return "big"
            }
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        body: {
            type:String,
            required: true
        },
        gameType: {
            type:String,
            required: true
        }
    },
};
</script>

<style scoped>
.divider {
    margin: 0 auto;
    border-top: 1px solid #ffffff;
    width: 50%;
    height: 1px;
}
.header {
    display: inline-block;
    position: absolute;
    z-index:4;
    left:0;
    top:0;
    width: 98%;
    height: 16%;
    border-radius:14px;
    background: rgba(255, 217, 0, 1);
    background: -moz-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(255, 217, 0, 1)),
        color-stop(54%, rgba(255, 217, 0, 1)),
        color-stop(75%, rgba(255, 153, 0, 1)),
        color-stop(100%, rgba(219, 88, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffd900', endColorstr='#db5800', GradientType=0 );
}
.big {
    height: 32%;
}
.outer {
    position: absolute;
    top: 10%;
    left: 5%;
    width: 90%;
    height: 75%;
    z-index: 2;
    background: rgba(165, 69, 5, 1);
    background: -moz-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(165, 69, 5, 1)),
        color-stop(22%, rgba(255, 153, 0, 1)),
        color-stop(44%, rgba(219, 88, 0, 1)),
        color-stop(72%, rgba(255, 217, 0, 1)),
        color-stop(80%, rgba(255, 153, 0, 1)),
        color-stop(100%, rgba(255, 217, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a54505', endColorstr='#ffd900', GradientType=0 );
}
.inner {
    width: 88%;
    height: 67%;
    position: absolute;
    top: 14%;
    left: 6%;
    z-index: 3;
    background:#7C0303;
    box-sizing: border-box;
    padding-left:3%;
    padding-right:3%;
}
</style>
